import { render, staticRenderFns } from "./message-bubble.vue?vue&type=template&id=2620969a&scoped=true"
import script from "./message-bubble.vue?vue&type=script&lang=js"
export * from "./message-bubble.vue?vue&type=script&lang=js"
import style0 from "./message-bubble.vue?vue&type=style&index=0&id=2620969a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2620969a",
  null
  
)

export default component.exports